import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Button } from '@mui/material';
import { Add, Label, DeleteSweep } from '@mui/icons-material';

const ActionButtons = ({ canEdit, setAddDialogOpen, setLabelDialogOpen, selectedAccounts, bulkDeleteAccounts }) => (
  <>
    {canEdit && (
      <Grid sx={{ flexShrink: 0 }}>
        <Button
          variant="outlined"
          startIcon={<Add />}
          onClick={() => setAddDialogOpen(true)}
          sx={{ 
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            borderWidth: 2,
            whiteSpace: 'nowrap',
            '&:hover': {
              borderWidth: 2,
              transform: 'translateY(-1px)',
              boxShadow: 2
            }
          }}
        >
          Add Account
        </Button>
      </Grid>
    )}
    {canEdit && (
      <Grid sx={{ flexShrink: 0 }}>
        <Button
          variant="outlined"
          startIcon={<Label />}
          onClick={() => setLabelDialogOpen(true)}
          sx={{ 
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            borderWidth: 2,
            whiteSpace: 'nowrap',
            '&:hover': {
              borderWidth: 2,
              transform: 'translateY(-1px)',
              boxShadow: 2
            }
          }}
        >
          Manage Status
        </Button>
      </Grid>
    )}
    {canEdit && selectedAccounts.length > 0 && (
      <Grid sx={{ flexShrink: 0 }}>
        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteSweep />}
          onClick={bulkDeleteAccounts}
          sx={{ 
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            borderWidth: 2,
            whiteSpace: 'nowrap',
            '&:hover': {
              borderWidth: 2,
              transform: 'translateY(-1px)',
              boxShadow: 2
            }
          }}
        >
          Delete ({selectedAccounts.length})
        </Button>
      </Grid>
    )}
  </>
);

ActionButtons.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  setAddDialogOpen: PropTypes.func.isRequired,
  setLabelDialogOpen: PropTypes.func.isRequired,
  selectedAccounts: PropTypes.array.isRequired,
  bulkDeleteAccounts: PropTypes.func.isRequired
};

export default ActionButtons;